import React, { useState }  from 'react';
//import '@atlaskit/css-reset';
import { DragDropContext } from 'react-beautiful-dnd';
import { ThemeProvider } from 'styled-components';
import Column from './Column'
import OptionsColumn from './OptionsColumn'
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import './DraggableCrossover.scss';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
    arrow: {
      "&:before": {
        border: "1px solid #E7DCDA",
        backgroundColor: "#B2292D",
      },
      color: "#FFF"
    },
    tooltip: {
        backgroundColor: "#B2292D",
        border: "1px solid #E7DCDA",
        color: "#FFF",
        fontSize: '11pt',
    }
  }));

function DraggableCrossover(props) {
    let classes = useStyles();
    const answer = props.options.slice(0,3)

    var option = {}
    answer.forEach(element => {
        option[element.id] = element
    });
    var initialColumns = {
            'options': {
                id: 'options',
                title: 'Answer Options',
                optionIds: answer.map(function (ele) { return ele.id; }),
            },
            'top1': {
                id: 'top1',
                title: 'Top 1',
                optionIds: []
            },
            'top2': {
                id: 'top2',
                title: 'Top 2',
                optionIds: []
            },
            'top3': {
                id: 'top3',
                title: 'Top 3',
                optionIds: []
            }
        }

    const [columns, setColumns] = useState(initialColumns)
    
    function onDragEnd(result) {
        const { destination, source, draggableId } = result
        if (!destination) {
            return
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return
        }

        const start = columns[source.droppableId]
        const finish = columns[destination.droppableId]

        if (start === finish) {
            const newOptionIds = Array.from(start.optionIds)
            newOptionIds.splice(source.index, 1)
            newOptionIds.splice(destination.index, 0, draggableId)

            const newOptions = {
                ...start,
                optionIds: newOptionIds
            }

            const newColumns = {
                ...columns,
                [newOptions.id]: newOptions
            }

            setColumns(newColumns);
            return
        }
        // Moving from one list to another 
        // Switch the existing element out from the destination
        else if ((finish.title === "Top 1" || finish.title === "Top 2" || finish.title === "Top 3") && finish.optionIds.length === 1) {
            const startOptionIds = Array.from(start.optionIds)
            startOptionIds.splice(source.index, 1, finish.optionIds[0])
            const newStart = {
                ...start,
                optionIds: startOptionIds
            }

            const newFinish = {
                ...finish,
                optionIds: [draggableId]
            }

            const newColumns = {
                ...columns,
                [newStart.id]: newStart,
                [newFinish.id]: newFinish
            }
            setColumns(newColumns)
        }
        else {
            const startOptionIds = Array.from(start.optionIds)
            startOptionIds.splice(source.index, 1)
            const newStart = {
                ...start,
                optionIds: startOptionIds
            }

            const finishOptionIds = Array.from(finish.optionIds)
            finishOptionIds.splice(destination.index, 0, draggableId)
            const newFinish = {
                ...finish,
                optionIds: finishOptionIds
            }

            const newColumn = {
                ...columns,
                [newStart.id]: newStart,
                [newFinish.id]: newFinish
            }
            setColumns(newColumn);
        }
        props.setDisplayTooltip(false);
    }

    function onClickSubmitResponse() {
        props.handleLockInResponse([columns["top1"].optionIds[0], columns["top2"].optionIds[0], columns["top3"].optionIds[0]])
    }
    
    return (
        <div className="answer-container">
            <DragDropContext onDragEnd={onDragEnd}>
                <Grid container spacing={2} >
                    <Grid item xs={4} className="column-container">
                        <ThemeProvider theme={{borderColor:'#B2292D'}}> 
                            <Column key={columns["top1"].id} column={columns["top1"]} options={columns["top1"].optionIds.map(optionId => option[optionId])} isDisabled={props.responseSubmitted} />
                        </ThemeProvider>
                    </Grid>
                    <Grid item xs={4} className="column-container">
                        <ThemeProvider theme={{borderColor:'#f4d06f'}}>
                            <Column key={columns["top2"].id} column={columns["top2"]} options={columns["top2"].optionIds.map(optionId => option[optionId])} isDisabled={props.responseSubmitted} borderColor='#B2292D' />
                        </ThemeProvider>
                    </Grid>
                    <Grid item xs={4} className="column-container">
                        <ThemeProvider theme={{borderColor:'#5B6586'}}>
                            <Column key={columns["top3"].id} column={columns["top3"]} options={columns["top3"].optionIds.map(optionId => option[optionId])} isDisabled={props.responseSubmitted} borderColor='#B2292D' />
                        </ThemeProvider>
                    </Grid>
                </Grid>
                <div className='answer-options-container'>
                    <div className='answer-options'>Answer Options</div>
                    <Tooltip title="Drag to the correct boxes" arrow open={props.displayTooltip} placement='right' classes={{ arrow: classes.arrow, tooltip: classes.tooltip }} >
                        <div className="column-container">
                            <ThemeProvider theme={{borderColor:'#000000'}}>
                                <OptionsColumn key={columns["options"].id} column={columns["options"]} options={columns["options"].optionIds.map(optionId => option[optionId])} isDisabled={props.responseSubmitted} borderColor='#B2292D' />
                            </ThemeProvider>
                        </div>
                    </Tooltip>
                </div>
            </DragDropContext>
            { props.responseSubmitted? null : 
                <div className='lock-in-btn-wrapper'>
                    <Button 
                        className="button-primary"
                        sx={{
                            color: 'white', 
                            '&:hover': {backgroundColor: '#A7B0CB'},
                        }} 
                        onClick={onClickSubmitResponse}
                        disabled={columns["top1"].optionIds.length === 0 || columns["top2"].optionIds.length === 0 || columns["top3"].optionIds.length === 0}>
                        Lock in Your Response
                    </Button>
                </div>
            }
        </div>
    )
}

export default DraggableCrossover;
